module.exports = __webpack_public_path__ + "img/FR14445.f0ac3767.png";